import React from "react";

/**
 * Écran de chargement plein écran, affiché tant que le profil de
 * l'utilisateur connecté n'est pas encore chargé (ex : juste après une
 * connexion, ou lors d'un rechargement de page) - évite d'afficher une
 * page blanche ou des informations manquantes/indéfinies pendant ce laps
 * de temps.
 */
export default function LoadingScreen({ message = "Chargement de vos informations…" }) {
  return (
    <div style={{
      minHeight: "100vh",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      gap: 16,
      background: "#F5F5F5",
      color: "#1a3d2b",
      fontFamily: "'Segoe UI', sans-serif",
    }}>
      <div style={{
        width: 44,
        height: 44,
        borderRadius: "50%",
        border: "4px solid #E0E0E0",
        borderTopColor: "#006B3C",
        animation: "setrag-loading-spin 0.7s linear infinite",
      }} />
      <div style={{ fontSize: 14, fontWeight: 600, color: "#666" }}>{message}</div>
      <style>{`@keyframes setrag-loading-spin { to { transform: rotate(360deg); } }`}</style>
    </div>
  );
}
